import { GetFragmentDto } from '@mi-front/core';
import { Box } from '@mui/material';
import { MediaStatus } from './media/MediaStatus';
import { SubtitlesStatusContainer } from './subtitle-status/SubtitleStatusContainer';

interface Props {
  readonly fragment: GetFragmentDto;
}

/**
 * Export "Files" tab content: media status and subtitles.
 */
export const FragmentFilesView = ({ fragment }: Props) => (
  <Box>
    <MediaStatus />
    {!!fragment.transcription?.completedAt && (
      <Box mt={3}>
        <SubtitlesStatusContainer />
      </Box>
    )}
  </Box>
);
